export default {
    options: {
        width: "100%",
        minHeight: 400,
    },
    buttons: [
        "source",
        "|",
        "bold",
        "strikethrough",
        "underline",
        "italic",
        "eraser",
        "|",
        "justify",
        "left",
        "right",
        "center",
        "undo",
        "redo",
        "copyformat",
        "hr",
        "print",
        "|",
        "superscript",
        "subscript",
        "|",
        "ul",
        "ol",
        "|",
        "outdent",
        "indent",
        "|",
        "font",
        "fontsize",
        "brush",
        "paragraph",
        "|",
        "image",
        // "file",
        "video",
        "table",
        "link",
    ],
};